var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaveSvgg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 262,
    viewBox: "0 0 1440 262",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.5625 262.434V137.544C96.4446 87.5877 230.938 105.569 319.202 137.544C419.218 173.776 595 240.061 815.016 233.293C886.225 231.102 1020.41 190.648 1093.46 129.218C1150.01 81.6603 1244.93 -55.2983 1438.38 24.4095C1441.61 25.7417 1438.38 61.0887 1438.38 84.5911V262.434H-0.5625Z",
    fill: "#F4D9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveSvgg);
export default __webpack_public_path__ + "static/media/waveSvgg.3551db4d521289d2ca6ed548ed036932.svg";
export { ForwardRef as ReactComponent };